export const ROUTES_FETCH_API_ROUTES = 'routes.fetch-api-routes';
export const ROUTES_SET_API_ROUTES = 'routes.set-api-routes';
export const ROUTES_CLEAR_API_ROUTES = 'routes.clear-api-routes';

export const ROUTES_FETCH_CLIENT_ROUTES = 'routes.fetch-client-routes';
export const ROUTES_SET_CLIENT_ROUTES = 'routes.set-client-routes';
export const ROUTES_CLEAR_CLIENT_ROUTES = 'routes.clear-client-routes';
